import { Injectable } from '@angular/core';
import { SettingsService } from '../shared-lib/core/settings';
import { AppService } from '../shared/app.service';

@Injectable({ providedIn: 'root' })
export class AppFlows {
  constructor(private appService: AppService, private settingsService: SettingsService) { }

  init() {
    this.settingsService.getPrintSettings$().subscribe(printSettings => {
      this.appService.setPrintSettings(printSettings);
    });

    if (this.appService.isMobileDevice) {
      this.settingsService.getWhatsappPhoneNumberForInApp$().subscribe(phoneNumber => {
        this.appService.setWhatsappPhoneNumber(phoneNumber);
      });
    } else {
      this.loadChatwoot();
    }

    this.settingsService.getBankInformation$().subscribe(bankInformation => {
      this.appService.setBankInformation(bankInformation);
    });

    this.settingsService.getGeneralSettings$().subscribe(generalSetting => {
      this.appService.setGeneralSettings(generalSetting);
    });

    this.settingsService.getBanners$().subscribe(appBanners => {
      this.appService.setAppBanners(appBanners);
    });
  }

  private loadChatwoot(): void {
    if (typeof document === 'undefined') return;
    if (document.getElementById('chatwoot-sdk')) return;

    // esto se controla desde el panel de Chatwoot, no es necesario configurar nada aquí
    // (window as any).chatwootSettings = { position: 'right', type: 'standard', launcherTitle: '' };
    (window as any).chatwootSettings = {
      locale: 'es', // para que el widget esté en español, algunos mensajes dinámicos se pueden personalizar desde el panel de Chatwoot
      useBrowserLanguage: false // para que obedezca el locale
    };

    const BASE_URL = 'https://chatwoot.copyfly.es';
    const script = document.createElement('script');
    script.id = 'chatwoot-sdk';
    script.src = `${BASE_URL}/packs/js/sdk.js`;
    script.async = true;
    script.defer = true;
    script.onload = () => {
      (window as any).chatwootSDK?.run({
        websiteToken: 'RZFree8RbQYeR3SmnHhWmEur',
        baseUrl: BASE_URL,
      });
    };
    document.head.appendChild(script);
  }
}
